import React, { useState, useEffect } from 'react';
import {
  Carousel as RCarousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators
} from 'reactstrap';
import './MobilePreviewCarousel.scss';

function MobilePreviewCarousel({ slides, activeIndex: controlledIndex, onChange }) {
  const isControlled = controlledIndex !== undefined && onChange;
  const [internalIndex, setInternalIndex] = useState(0);

  useEffect(() => {
    if (isControlled) setInternalIndex(controlledIndex);
  }, [controlledIndex, isControlled]);

  const activeIndex = isControlled ? controlledIndex : internalIndex;

  const next = () => {
    const nextIndex = (activeIndex + 1) % slides.length;
    isControlled ? onChange(nextIndex) : setInternalIndex(nextIndex);
  };

  const previous = () => {
    const prevIndex = (activeIndex - 1 + slides.length) % slides.length;
    isControlled ? onChange(prevIndex) : setInternalIndex(prevIndex);
  };

  const goToIndex = (newIndex) => {
    isControlled ? onChange(newIndex) : setInternalIndex(newIndex);
  };

  const renderedSlides = slides.map((slide, index) => (
    <CarouselItem key={slide.id}>
      {slide.content}
    </CarouselItem>
  ));

  return (
    <div className="mobile-preview-carousel-wrapper">
      <RCarousel activeIndex={activeIndex} next={next} previous={previous} interval={false} slide={false}>
        <CarouselIndicators
          items={slides}
          activeIndex={activeIndex}
          onClickHandler={goToIndex}
        />
        {renderedSlides}
        <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} />
        <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
      </RCarousel>

      <div className="custom-carousel-indicators">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`dot ${index === activeIndex ? 'active' : ''}`}
            onClick={() => goToIndex(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
}

export default MobilePreviewCarousel;
